import { isHostedHttpUrl } from "./isHostedHttpUrl";

const HOSTED_URL_KEYS = [
  "options[design-front-image-custom]",
  "options[design-rear-image-custom]",
  "options[lit-texture-src]",
];

export function hostedConfigurationUrls(cartObj) {
  return HOSTED_URL_KEYS.map((key) => cartObj?.[key]).filter(isHostedHttpUrl);
}

function fragmentOf(url) {
  const cut = url.indexOf("#");
  return cut === -1 ? "" : url.slice(cut);
}

function withHash(url, hash) {
  const cut = url.indexOf("#");
  const withoutHash = cut === -1 ? url : url.slice(0, cut);
  const nextHash = hash.charAt(0) === "#" ? hash : `#${hash}`;
  return withoutHash + nextHash;
}

function fragmentHasHostedUrl(fragment, hostedUrls) {
  if (!fragment) return false;
  return hostedUrls.some((value) => {
    if (!isHostedHttpUrl(value)) return false;
    return fragment.includes(value) || fragment.includes(encodeURIComponent(value));
  });
}

/**
 * Parent page URL when embedded, otherwise this window.
 * The hash string is the one UrlDataController already writes.
 * If parentUrl is behind that hash (or missing it), only the hash is replaced.
 */
export function configurationPageUrl({ parentUrl = "", href = "", hash = "", hostedUrls = [] } = {}) {
  const base = parentUrl || href || "";
  if (!base) return "";

  const liveHash = hash && hash !== "#" && hash !== "#/" ? hash : "";
  if (!liveHash) return base;

  const baseHash = fragmentOf(base);
  if (baseHash === liveHash) return base;

  const urls = hostedUrls.filter(isHostedHttpUrl);
  const baseHasImage = fragmentHasHostedUrl(baseHash, urls);
  const liveHasImage = fragmentHasHostedUrl(liveHash, urls);
  if (baseHasImage && !liveHasImage) return base;
  if (liveHasImage && !baseHasImage) return withHash(base, liveHash);
  if (!baseHash || baseHash === "#" || baseHash === "#/") return withHash(base, liveHash);
  return base;
}

// The iframe boots at its own origin with an empty hash. The saved configuration
// lives on the parent. Reading that hash on the first render keeps shopping_cart
// (and the JSON) from being replaced by the default baseColor_default state.
export function initialEmbedHash(iframeHash, parentHash) {
  const iframeBlank = !iframeHash || iframeHash === "#" || iframeHash === "#/";
  if (parentHash && parentHash !== "#" && parentHash !== "#/" && iframeBlank) return parentHash;
  return iframeHash || "#/";
}

export function shouldPreserveSavedHash(iframeHash, savedHash, nextHash, itemsLoaded = true) {
  const saved = initialEmbedHash("#/", savedHash);
  if (!saved || saved === "#/" || nextHash === saved) return false;
  const iframeBlank = !iframeHash || iframeHash === "#" || iframeHash === "#/";
  if (iframeBlank) return true;
  // Item state is still empty, so this write is the default baseColor_default payload.
  return itemsLoaded === false;
}
